import { useState } from 'react';
import { apiErrorText, useUploadFsnbEditionMutation } from '@shared/api';
import { Card } from '@shared/ui/Card';
import { FileDropZone } from '@shared/ui/FileDropZone';
import { Alert, BlockTitle, Lead } from '../styles';

/** Загрузка архива дополнения с ФГИС ЦС. */
export function UploadBlock() {
  const [upload, { isLoading }] = useUploadFsnbEditionMutation();
  const [message, setMessage] = useState<{ tone: 'danger' | 'success'; text: string } | null>(null);

  async function onFile(file: File) {
    setMessage(null);
    const form = new FormData();
    form.append('file', file);
    try {
      const r = await upload(form).unwrap();
      setMessage({
        tone: 'success',
        text: `«${r.edition.title}» загружена и разбирается — обычно это минута-две. Когда разбор закончится, здесь появятся изменения против действующей редакции.`,
      });
    } catch (e) {
      setMessage({ tone: 'danger', text: apiErrorText(e, 'Архив не принят.') });
    }
  }

  return (
    <Card>
      <BlockTitle>Загрузить дополнение</BlockTitle>
      <Lead>
        Архив скачивается на ФГИС ЦС: «ФРСН» → «ФСНБ» → нужное дополнение (при скачивании сайт
        просит ввести код с картинки). Загрузите его как есть, распаковывать не нужно. Новая
        редакция сначала встаёт на проверку: расчёты идут по действующей, пока новую не введут в
        действие.
      </Lead>
      <FileDropZone
        accept=".zip"
        compact
        disabled={isLoading}
        primary={
          isLoading ? 'Загружаем архив…' : 'Перетащите архив ФСНБ-2022 (.zip) или выберите файл'
        }
        hint="Архив дополнения — полный срез базы: промежуточные дополнения загружать не нужно"
        onFile={(f) => void onFile(f)}
      />
      {message && <Alert $tone={message.tone}>{message.text}</Alert>}
    </Card>
  );
}
